import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feestructure.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
// import Spinner from "react-bootstrap/Spinner";
import ScaleLoader from "react-spinners/ScaleLoader";
// Note: Ensure simplePostCall and ApiConfig are imported or available globally
// import { simplePostCall } from "../../Services/ApiServices";
// import { ApiConfig } from "../../Config/ApiConfig";

export default function Feestructure() {
  // 1. Added missing state for studentList (or academicYears)
  const [academicYears, setAcademicYears] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  const loadDataStudentFee = async (searchQuery = "") => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: searchQuery,
    };

    try {
      // Using your simplePostCall logic
      const response = await simplePostCall(
        ApiConfig.feeStructurelist,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        // Set the academic year data from the API
        setAcademicYears(response.data);
      } else {
        setAcademicYears([]);
      }
    } catch (error) {
      console.error("Error loading student list:", error);
      setAcademicYears([]);
    } finally {
      setIsLoading(false);
    }
  };


  

  return (
    <div className="feestruc-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Fee Structures</h4>
      </div>

      <div className="yc-list-body">
        <div className="row feestruct-cardbg g-3">
          {isLoading ? (
            <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
              <ScaleLoader color="#F4BB44" />
            </div>
          ) : academicYears.length > 0 ? (
            academicYears.map((item, index) => (
              <div className="col-md-12 col-lg-4 col-sm-12" key={index}>
                <div className={`card feestruc-cardss-${(index % 10) + 1} text-center`}>
                  <div className="card-body">
                    <h5 className="card-title">
                      <b>{item.academic_year_name}</b>
                    </h5>
                    <div className="card-text">
                      <p className="mb-1">
                        Start Date: {new Date(item.academic_year_start_date).toDateString()}
                      </p>
                      <p>
                        End Date: {new Date(item.academic_year_end_date).toDateString()}
                      </p>
                    </div>
                    <Link
                      to={`/firstcard/${item.academic_year_id}`}
                      className="btn btn-primary btn-sm"
                      state={item}
                    >
                      <i className="bi bi-arrow-up-right-square-fill"></i> View
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="yc-empty-state">No fee structures found.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
